import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useUser } from '../components/context/UserContext'

function Header() {
  const [contactInfo, setContactInfo] = useState({
    address: "Khulna, Dhaka",
    phone: "+012 345 6789",
    email: "info@example.com"
  });
  const [socialLinks, setSocialLinks] = useState([]);
  const [loadingContact, setLoadingContact] = useState(false);
  const [loadingSocialLinks, setLoadingSocialLinks] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false)
  const [loginForm, setLoginForm] = useState({
    email: '',
    password: ''
  })
  const [registerForm, setRegisterForm] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    phone: '',
    address: ''
  })
  const [isLogin, setIsLogin] = useState(true)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const { user, login, register, signInWithGoogle, logout } = useUser()

  // Fetch contact information from API
  useEffect(() => {
    fetchContactInfo();
    fetchSocialLinks();
  }, []);

  const fetchContactInfo = async () => {
    try {
      setLoadingContact(true);
      const response = await fetch('https://travel-agency-server-lilac.vercel.app/api/contact/contact-info');

      if (!response.ok) {
        throw new Error('Failed to fetch contact info');
      }

      const data = await response.json();

      if (data.success && data.contactInfo) {
        setContactInfo(data.contactInfo);
      }
    } catch (error) {
      console.error('Failed to fetch contact info:', error);
      // Keep default values if API fails
    } finally {
      setLoadingContact(false);
    }
  };

  // Fetch social links function - ✅ CORRECTED ENDPOINT
  // Header.js এর fetchSocialLinks ফাংশনে এড করুন
  const fetchSocialLinks = async () => {
    try {
      setLoadingSocialLinks(true);
      const response = await fetch('https://travel-agency-server-lilac.vercel.app/api/social-links');

      if (!response.ok) {
        throw new Error('Failed to fetch social links');
      }

      const data = await response.json();

      if (data.success && data.socialLinks) {
        // Filter out duplicates by platform (keep only first occurrence)
        const uniqueLinks = [];
        const platformSet = new Set();

        data.socialLinks.forEach(link => {
          if (!platformSet.has(link.platform)) {
            platformSet.add(link.platform);
            uniqueLinks.push(link);
          }
        });

        setSocialLinks(uniqueLinks);
      }
    } catch (error) {
      console.error('Failed to fetch social links:', error);
      // Keep empty array if API fails
      setSocialLinks([]);
    } finally {
      setLoadingSocialLinks(false);
    }
  };

  const handleLoginChange = (e) => {
    setLoginForm({
      ...loginForm,
      [e.target.name]: e.target.value
    })
  }

  const handleRegisterChange = (e) => {
    setRegisterForm({
      ...registerForm,
      [e.target.name]: e.target.value
    })
  }

  const handleLogin = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError('')

    const result = await login(loginForm.email, loginForm.password)

    if (result.success) {
      setShowLoginModal(false)
      setLoginForm({ email: '', password: '' })
    } else {
      setError(result.message)
    }
    setLoading(false)
  }

  const handleRegister = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError('')

    if (registerForm.password !== registerForm.confirmPassword) {
      setError('Passwords do not match')
      setLoading(false)
      return
    }

    if (registerForm.password.length < 6) {
      setError('Password must be at least 6 characters long')
      setLoading(false)
      return
    }

    const userData = {
      name: registerForm.name,
      email: registerForm.email,
      password: registerForm.password,
      phone: registerForm.phone,
      address: registerForm.address
    }

    const result = await register(userData)

    if (result.success) {
      setShowLoginModal(false)
      setRegisterForm({
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
        phone: '',
        address: ''
      })
      // Switch to login form after successful registration
      setIsLogin(true)
    } else {
      setError(result.message)
    }
    setLoading(false)
  }

  const handleGoogleSignIn = async () => {
    setLoading(true)
    setError('')

    const result = await signInWithGoogle()

    if (result.success) {
      setShowLoginModal(false)
    } else {
      setError(result.message)
    }
    setLoading(false)
  }

  const handleLogout = () => {
    logout()
  }

  // Fix profile picture URL for Google images
  const getProfilePictureUrl = (photoURL) => {
    if (!photoURL) return null;

    // Fix Google profile picture URL
    if (photoURL.includes('googleusercontent.com') && photoURL.includes('=s96-c')) {
      return photoURL.replace('=s96-c', '=s400-c');
    }

    return photoURL;
  }

  // Get platform display name
  const getPlatformDisplayName = (platform) => {
    const platformNames = {
      'facebook': 'Facebook',
      'twitter': 'Twitter',
      'instagram': 'Instagram',
      'linkedin': 'LinkedIn',
      'youtube': 'YouTube',
      'tiktok': 'TikTok',
      'pinterest': 'Pinterest',
      'whatsapp': 'WhatsApp',
      'snapchat': 'Snapchat',
      'telegram': 'Telegram'
    };
    return platformNames[platform] || platform;
  };

  // Get platform icon
  const getPlatformIcon = (platform, customIcon = '') => {
    if (customIcon) return customIcon;

    const platformIcons = {
      'facebook': 'fab fa-facebook-f',
      'twitter': 'fab fa-twitter',
      'instagram': 'fab fa-instagram',
      'linkedin': 'fab fa-linkedin-in',
      'youtube': 'fab fa-youtube',
      'tiktok': 'fab fa-tiktok',
      'pinterest': 'fab fa-pinterest',
      'whatsapp': 'fab fa-whatsapp',
      'snapchat': 'fab fa-snapchat',
      'telegram': 'fab fa-telegram'
    };
    return platformIcons[platform] || 'fas fa-link';
  };

  return (
    <div>
      <style>
        {`
          /* Custom CSS for Header Navigation */
          .navbar-light .navbar-nav .nav-link {
            color: #000000 !important;
            font-weight: 500;
            transition: all 0.3s ease;
          }

          .navbar-light .navbar-nav .nav-link:hover,
          .navbar-light .navbar-nav .nav-link:focus {
            color: #007bff !important;
            transform: translateY(-2px);
          }

          .navbar-light .navbar-nav .nav-link.active {
            color: #007bff !important;
            font-weight: 600;
          }

          .navbar-light .navbar-nav .dropdown-menu {
            border: none;
            box-shadow: 0 5px 15px rgba(0,0,0,0.1);
            border-radius: 10px;
            min-width: 250px;
          }

          .navbar-light .navbar-nav .dropdown-item {
            color: #333;
            transition: all 0.3s ease;
            padding: 8px 16px;
          }

          .navbar-light .navbar-nav .dropdown-item:hover {
            background-color: #007bff;
            color: white;
            transform: translateX(5px);
          }

          /* Navbar background fix */
          .navbar-light {
            background-color: #ffffff !important;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          }

          /* Ensure text is visible on all screen sizes */
          @media (max-width: 991px) {
            .navbar-collapse {
              background-color: #ffffff;
              padding: 20px;
              border-radius: 10px;
              margin-top: 10px;
              box-shadow: 0 5px 15px rgba(0,0,0,0.1);
            }
            
            .navbar-nav .nav-link {
              padding: 10px 15px !important;
              border-bottom: 1px solid #f8f9fa;
            }
            
            .navbar-nav .nav-link:last-child {
              border-bottom: none;
            }

            .user-dropdown {
              margin-top: 15px;
            }
          }

          /* User dropdown styles */
          .user-dropdown .dropdown-toggle {
            border: none;
            background: transparent;
            color: #007bff;
            font-weight: 500;
          }

          .user-dropdown .dropdown-toggle::after {
            margin-left: 8px;
          }

          .user-avatar {
            width: 40px;
            height: 40px;
            background: linear-gradient(135deg, #007bff, #0056b3);
            color: white;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justifyContent: center;
            font-weight: bold;
            font-size: 16px;
            border: 2px solid white;
            box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          }

          .user-avatar-img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            object-fit: cover;
            border: 2px solid white;
            box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          }

          /* Google Sign-In Button */
          .google-signin-btn {
            background: white;
            color: #757575;
            border: 2px solid #dadce0;
            border-radius: 8px;
            padding: 12px 16px;
            font-weight: 500;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 12px;
            transition: all 0.3s ease;
            margin-bottom: 16px;
          }

          .google-signin-btn:hover {
            background: #f8f9fa;
            border-color: #d2e3fc;
            box-shadow: 0 2px 8px rgba(0,0,0,0.1);
            transform: translateY(-1px);
          }

          .google-signin-btn:active {
            transform: translateY(0);
          }

          .google-signin-btn:disabled {
            opacity: 0.6;
            cursor: not-allowed;
            transform: none;
          }

          .google-icon {
            width: 18px;
            height: 18px;
          }

          /* Divider */
          .divider {
            display: flex;
            align-items: center;
            text-align: center;
            margin: 20px 0;
            color: #6c757d;
            font-size: 14px;
          }

          .divider::before,
          .divider::after {
            content: '';
            flex: 1;
            border-bottom: 1px solid #dee2e6;
          }

          .divider::before {
            margin-right: 16px;
          }

          .divider::after {
            margin-left: 16px;
          }

          /* Custom modal styles */
          .custom-modal {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0,0,0,0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1050;
          }

          .custom-modal-content {
            background: white;
            border-radius: 15px;
            max-width: 450px;
            width: 90%;
            max-height: 90vh;
            overflow-y: auto;
            animation: modalSlideIn 0.3s ease-out;
          }

          @keyframes modalSlideIn {
            from {
              opacity: 0;
              transform: translateY(-50px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          /* User info in dropdown */
          .user-info {
            padding: 12px 16px;
            border-bottom: 1px solid #e9ecef;
          }

          .user-name {
            font-weight: 600;
            color: #333;
            margin-bottom: 4px;
          }

          .user-email {
            font-size: 12px;
            color: #6c757d;
            margin-bottom: 8px;
          }

          .user-role-badge {
            font-size: 11px;
            padding: 2px 6px;
          }

          /* Loading animation */
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }

          .spinner {
            animation: spin 1s linear infinite;
          }

          /* ✅ NEW: Enhanced Login/Register Form Styles */
          .auth-modal-header {
            border-bottom: 1px solid #e9ecef;
            padding: 1.5rem 1.5rem 0;
          }

          .auth-modal-title {
            font-size: 1.5rem;
            font-weight: 700;
            color: #2d3748;
            margin-bottom: 0.5rem;
          }

          .auth-modal-subtitle {
            color: #718096;
            font-size: 0.875rem;
            margin-bottom: 1rem;
          }

          .auth-modal-body {
            padding: 1.5rem;
          }

          .form-label {
            font-weight: 600;
            color: #4a5568;
            margin-bottom: 0.5rem;
            font-size: 0.875rem;
          }

          .form-control-lg {
            padding: 0.75rem 1rem;
            font-size: 1rem;
            border: 2px solid #e2e8f0;
            border-radius: 8px;
            transition: all 0.3s ease;
          }

          .form-control-lg:focus {
            border-color: #007bff;
            box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
            outline: none;
          }

          .form-control-lg:disabled {
            background-color: #f7fafc;
            opacity: 0.7;
            cursor: not-allowed;
          }

          .btn-primary {
            background: linear-gradient(135deg, #007bff, #0056b3);
            border: none;
            border-radius: 8px;
            font-weight: 600;
            padding: 0.875rem 1.5rem;
            transition: all 0.3s ease;
            box-shadow: 0 2px 4px rgba(0, 123, 255, 0.2);
          }

          .btn-primary:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
          }

          .btn-primary:disabled {
            transform: none;
            box-shadow: none;
            opacity: 0.7;
          }

          .btn-link {
            color: #007bff;
            text-decoration: none;
            font-weight: 500;
            transition: all 0.3s ease;
          }

          .btn-link:hover {
            color: #0056b3;
            text-decoration: underline;
          }

          .alert-danger {
            background-color: #fed7d7;
            border: 1px solid #feb2b2;
            color: #c53030;
            border-radius: 8px;
            padding: 0.75rem 1rem;
            font-size: 0.875rem;
          }

          /* Input group enhancements */
          .input-group {
            margin-bottom: 1rem;
          }

          .input-group-text {
            background-color: #f7fafc;
            border: 2px solid #e2e8f0;
            border-right: none;
          }

          .form-control {
            border-left: none;
          }

          /* Password strength indicator */
          .password-strength {
            height: 4px;
            border-radius: 2px;
            margin-top: 0.25rem;
            background-color: #e2e8f0;
            overflow: hidden;
          }

          .password-strength-fill {
            height: 100%;
            transition: all 0.3s ease;
          }

          .password-strength.weak .password-strength-fill {
            background-color: #e53e3e;
            width: 33%;
          }

          .password-strength.medium .password-strength-fill {
            background-color: #dd6b20;
            width: 66%;
          }

          .password-strength.strong .password-strength-fill {
            background-color: #38a169;
            width: 100%;
          }

          /* Form validation styles */
          .is-invalid {
            border-color: #e53e3e !important;
          }

          .is-valid {
            border-color: #38a169 !important;
          }

          .invalid-feedback {
            display: block;
            color: #e53e3e;
            font-size: 0.75rem;
            margin-top: 0.25rem;
          }

          /* Modal close button */
          .btn-close {
            padding: 0.5rem;
            margin: -0.5rem -0.5rem -0.5rem auto;
          }

          /* Responsive adjustments */
          @media (max-width: 576px) {
            .custom-modal-content {
              margin: 1rem;
              width: calc(100% - 2rem);
            }
            
            .auth-modal-body {
              padding: 1rem;
            }
            
            .btn-primary {
              padding: 0.75rem 1rem;
            }
          }

          /* Animation for form switching */
          .auth-form-enter {
            opacity: 0;
            transform: translateX(20px);
          }

          .auth-form-enter-active {
            opacity: 1;
            transform: translateX(0);
            transition: all 0.3s ease;
          }

          /* Custom scrollbar for modal */
          .custom-modal-content::-webkit-scrollbar {
            width: 6px;
          }

          .custom-modal-content::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 3px;
          }

          .custom-modal-content::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 3px;
          }

          .custom-modal-content::-webkit-scrollbar-thumb:hover {
            background: #a8a8a8;
          }

          /* Enhanced focus states */
          .form-control:focus,
          .btn:focus,
          .google-signin-btn:focus {
            outline: none;
            box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
          }

          /* Placeholder styling */
          .form-control::placeholder {
            color: #a0aec0;
            font-size: 0.875rem;
          }

          /* Success state for forms */
          .was-validated .form-control:valid {
            border-color: #38a169;
            background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2338a169' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
            background-repeat: no-repeat;
            background-position: right calc(0.375em + 0.1875rem) center;
            background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
          }

          /* ✅ NEW: Social links loading animation */
          .social-links-loading {
            display: inline-flex;
            gap: 8px;
          }
          
          .social-links-loading .loading-dot {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background-color: rgba(255, 255, 255, 0.7);
            animation: socialPulse 1.5s infinite;
          }
          
          .social-links-loading .loading-dot:nth-child(2) {
            animation-delay: 0.2s;
          }
          
          .social-links-loading .loading-dot:nth-child(3) {
            animation-delay: 0.4s;
          }
          
          @keyframes socialPulse {
            0%, 100% { transform: scale(1); opacity: 0.7; }
            50% { transform: scale(1.3); opacity: 1; }
          }

          /* Social links tooltip enhancement */
          .social-link-btn {
            transition: all 0.3s ease;
            position: relative;
          }

          .social-link-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
          }

          .social-link-btn::after {
            content: attr(title);
            position: absolute;
            bottom: 100%;
            left: 50%;
            transform: translateX(-50%);
            background-color: #333;
            color: white;
            padding: 4px 8px;
            border-radius: 4px;
            font-size: 12px;
            white-space: nowrap;
            opacity: 0;
            visibility: hidden;
            transition: all 0.3s ease;
            z-index: 1000;
            margin-bottom: 8px;
          }

          .social-link-btn:hover::after {
            opacity: 1;
            visibility: visible;
          }
        `}
      </style>

      {/* Topbar Start */}
      <div className="container-fluid bg-dark px-5 d-none d-lg-block">
        <div className="row gx-0">
          <div className="col-lg-8 text-center text-lg-start mb-2 mb-lg-0">
            <div className="d-inline-flex align-items-center" style={{ height: 45 }}>
              {loadingContact ? (
                <div className="d-flex align-items-center">
                  <div className="spinner-border spinner-border-sm text-light me-2" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <small className="text-light">Loading contact info...</small>
                </div>
              ) : (
                <>
                  <small className="me-3 text-light">
                    <i className="fa fa-map-marker-alt me-2" />
                    {contactInfo.address}
                  </small>
                  <small className="me-3 text-light">
                    <i className="fa fa-phone-alt me-2" />
                    {contactInfo.phone}
                  </small>
                  <small className="text-light">
                    <i className="fa fa-envelope-open me-2" />
                    {contactInfo.email}
                  </small>
                </>
              )}
            </div>
          </div>
          <div className="col-lg-4 text-center text-lg-end">
            <div className="d-inline-flex align-items-center" style={{ height: 45 }}>
              {loadingSocialLinks ? (
                <div className="social-links-loading">
                  <div className="loading-dot"></div>
                  <div className="loading-dot"></div>
                  <div className="loading-dot"></div>
                </div>
              ) : (
                <>
                  {socialLinks
                    .filter(link => link.isActive)
                    .sort((a, b) => a.displayOrder - b.displayOrder)
                    .map((link) => (
                      <a
                        key={link._id || link.platform}
                        className="social-link-btn btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        title={getPlatformDisplayName(link.platform)}
                      >
                        <i className={getPlatformIcon(link.platform, link.customIcon) + ' fw-normal'}></i>
                      </a>
                    ))
                  }
                  {socialLinks.filter(link => link.isActive).length === 0 && (
                    <small className="text-light">
                      <i className="fas fa-share-alt me-1"></i>
                      Follow Us
                    </small>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Topbar End */}

      {/* Navbar & Hero Start */}
      <div className="container-fluid position-relative p-0">
        <nav className="navbar navbar-expand-lg navbar-light px-4 px-lg-5 py-3 py-lg-0">
          <Link to="/" className="navbar-brand p-0">
            <h1 className="text-primary m-0">
              <img
                style={{ width: "77px" }}
                src="/assets/img/navbrand.png"
                alt="Asian Travel Agency Logo"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'block';
                }}
              />
              <span style={{ display: 'none', fontSize: '24px', fontWeight: 'bold' }}>🌏 Travel</span>
            </h1>
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
            aria-controls="navbarCollapse"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="fa fa-bars" />
          </button>
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <div className="navbar-nav ms-auto py-0">
              <Link to="/" className="nav-item nav-link active">Home</Link>
              <Link to="/about" className="nav-item nav-link">About</Link>
              <Link to="/services" className="nav-item nav-link">Services</Link>
              <Link to="/packages" className="nav-item nav-link">Packages</Link>
              <div className="nav-item dropdown">
                <Link to="#" className="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button" aria-expanded="false">
                  Pages
                </Link>
                <div className="dropdown-menu m-0">
                  <Link to="/destination" className="dropdown-item">Destination</Link>
                  <Link to="/booking" className="dropdown-item">Booking</Link>
                  <Link to="/testimonial" className="dropdown-item">Testimonial</Link>
                </div>
              </div>
              <Link to="/contact" className="nav-item nav-link">Contact</Link>

              {/* User Dashboard Link - Show for all logged in users */}
              {user && (
                <Link to="/user-dashboard" className="nav-item nav-link">
                  <i className="fas fa-user-circle me-1"></i>
                  My Account
                </Link>
              )}

              {/* Admin Dashboard Link - Show only for admins */}
              {user && user.role === 'admin' && (
                <Link to="/admin" className="nav-item nav-link">
                  <i className="fas fa-crown me-1"></i>
                  Admin
                </Link>
              )}
            </div>

            {/* User Profile Section */}
            {user ? (
              <div className="dropdown user-dropdown ms-3">
                <button
                  className="btn btn-outline-primary rounded-pill py-2 px-4 dropdown-toggle d-flex align-items-center"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {user.photoURL ? (
                    <img
                      src={getProfilePictureUrl(user.photoURL)}
                      alt={user.name}
                      className="user-avatar-img me-2"
                      onError={(e) => {
                        // If image fails to load, hide it and show fallback
                        e.target.style.display = 'none';
                        const fallback = e.target.nextElementSibling;
                        if (fallback) fallback.style.display = 'flex';
                      }}
                    />
                  ) : null}
                  <div
                    className="user-avatar me-2"
                    style={{ display: user.photoURL ? 'none' : 'flex' }}
                  >
                    {user.name ? user.name.charAt(0).toUpperCase() : 'U'}
                  </div>
                  <span className="d-none d-md-inline">{user.name}</span>
                </button>
                <ul className="dropdown-menu dropdown-menu-end">
                  <li>
                    <div className="user-info">
                      <div className="user-name">{user.name}</div>
                      <div className="user-email">{user.email}</div>
                      <div>
                        {user.role === 'admin' && (
                          <span className="badge bg-success user-role-badge">Admin</span>
                        )}
                        {user.role === 'pending' && (
                          <span className="badge bg-warning user-role-badge">Pending Admin</span>
                        )}
                        {user.role === 'user' && (
                          <span className="badge bg-info user-role-badge">User</span>
                        )}
                      </div>
                    </div>
                  </li>
                  <li><hr className="dropdown-divider my-2" /></li>
                  <li>
                    <Link to="/user-dashboard" className="dropdown-item">
                      <i className="fas fa-tachometer-alt me-2"></i>
                      Dashboard
                    </Link>
                  </li>
                  <li>
                    <Link to="/user-profile" className="dropdown-item">
                      <i className="fas fa-user-edit me-2"></i>
                      Edit Profile
                    </Link>
                  </li>
                  {user.role === 'admin' && (
                    <>
                      <li><hr className="dropdown-divider my-2" /></li>
                      <li>
                        <Link to="/admin-dashboard" className="dropdown-item">
                          <i className="fas fa-crown me-2"></i>
                          Admin Panel
                        </Link>
                      </li>
                    </>
                  )}
                  <li><hr className="dropdown-divider my-2" /></li>
                  <li>
                    <button
                      className="dropdown-item text-danger"
                      onClick={handleLogout}
                    >
                      <i className="fas fa-sign-out-alt me-2"></i>
                      Logout
                    </button>
                  </li>
                </ul>
              </div>
            ) : (
              <button
                className="btn btn-primary rounded-pill py-2 px-4 ms-3"
                onClick={() => setShowLoginModal(true)}
                aria-label="Sign in to your account"
              >
                <i className="fas fa-sign-in-alt me-2"></i>
                Sign In
              </button>
            )}
          </div>
        </nav>
      </div>
      {/* Navbar & Hero End */}

      {/* Login/Register Modal */}
      {showLoginModal && (
        <div className="custom-modal">
          <div className="custom-modal-content">
            <div className="auth-modal-header">
              <div className="d-flex justify-content-between align-items-center w-100">
                <div>
                  <h5 className="auth-modal-title">
                    {isLogin ? 'Welcome Back!' : 'Create Your Account'}
                  </h5>
                  <p className="auth-modal-subtitle">
                    {isLogin ? 'Sign in to your account to continue' : 'Join us and start your journey'}
                  </p>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowLoginModal(false)
                    setError('')
                    setIsLogin(true)
                  }}
                  aria-label="Close"
                ></button>
              </div>
            </div>
            <div className="auth-modal-body">
              {error && (
                <div className="alert alert-danger d-flex align-items-center" role="alert">
                  <i className="fas fa-exclamation-triangle me-2"></i>
                  <div>{error}</div>
                </div>
              )}

              {/* Google Sign-In Button */}
              <button
                className="google-signin-btn"
                onClick={handleGoogleSignIn}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <div className="spinner-border spinner-border-sm text-primary me-2" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    Signing in...
                  </>
                ) : (
                  <>
                    <svg className="google-icon" viewBox="0 0 24 24" width="18" height="18">
                      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                      <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                    </svg>
                    Continue with Google
                  </>
                )}
              </button>

              <div className="divider">
                or continue with email
              </div>

              {isLogin ? (
                <form onSubmit={handleLogin} className="auth-form-enter-active">
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">Email Address</label>
                    <input
                      type="email"
                      className="form-control form-control-lg"
                      id="email"
                      name="email"
                      value={loginForm.email}
                      onChange={handleLoginChange}
                      required
                      placeholder="Enter your email"
                      disabled={loading}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="password" className="form-label">Password</label>
                    <input
                      type="password"
                      className="form-control form-control-lg"
                      id="password"
                      name="password"
                      value={loginForm.password}
                      onChange={handleLoginChange}
                      required
                      placeholder="Enter your password"
                      disabled={loading}
                    />
                  </div>
                  <button
                    type="submit"
                    className="btn btn-primary btn-lg w-100 py-3 fw-semibold"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Signing In...
                      </>
                    ) : (
                      'Sign In to Your Account'
                    )}
                  </button>
                </form>
              ) : (
                <form onSubmit={handleRegister} className="auth-form-enter-active">
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">Full Name</label>
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      id="name"
                      name="name"
                      value={registerForm.name}
                      onChange={handleRegisterChange}
                      required
                      placeholder="Enter your full name"
                      disabled={loading}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="regEmail" className="form-label">Email Address</label>
                    <input
                      type="email"
                      className="form-control form-control-lg"
                      id="regEmail"
                      name="email"
                      value={registerForm.email}
                      onChange={handleRegisterChange}
                      required
                      placeholder="Enter your email"
                      disabled={loading}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="phone" className="form-label">Phone Number (Optional)</label>
                    <input
                      type="tel"
                      className="form-control form-control-lg"
                      id="phone"
                      name="phone"
                      value={registerForm.phone}
                      onChange={handleRegisterChange}
                      placeholder="Enter your phone number"
                      disabled={loading}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="address" className="form-label">Address (Optional)</label>
                    <textarea
                      className="form-control form-control-lg"
                      id="address"
                      name="address"
                      value={registerForm.address}
                      onChange={handleRegisterChange}
                      rows="2"
                      placeholder="Enter your address"
                      disabled={loading}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="regPassword" className="form-label">Password</label>
                    <input
                      type="password"
                      className="form-control form-control-lg"
                      id="regPassword"
                      name="password"
                      value={registerForm.password}
                      onChange={handleRegisterChange}
                      required
                      minLength="6"
                      placeholder="Enter your password (min 6 characters)"
                      disabled={loading}
                    />
                    <div className="password-strength">
                      <div className="password-strength-fill"></div>
                    </div>
                  </div>
                  <div className="mb-3">
                    <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>
                    <input
                      type="password"
                      className="form-control form-control-lg"
                      id="confirmPassword"
                      name="confirmPassword"
                      value={registerForm.confirmPassword}
                      onChange={handleRegisterChange}
                      required
                      placeholder="Confirm your password"
                      disabled={loading}
                    />
                  </div>
                  <button
                    type="submit"
                    className="btn btn-primary btn-lg w-100 py-3 fw-semibold"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Creating Account...
                      </>
                    ) : (
                      'Create Your Account'
                    )}
                  </button>
                </form>
              )}

              <div className="text-center mt-4">
                <button
                  type="button"
                  className="btn btn-link p-0 border-0 bg-transparent text-decoration-none text-primary fw-semibold"
                  onClick={() => {
                    setIsLogin(!isLogin)
                    setError('')
                    setLoginForm({ email: '', password: '' })
                    setRegisterForm({
                      name: '',
                      email: '',
                      password: '',
                      confirmPassword: '',
                      phone: '',
                      address: ''
                    })
                  }}
                  disabled={loading}
                >
                  {isLogin ? "Don't have an account? Sign up" : 'Already have an account? Sign in'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Header